import { render, staticRenderFns } from "./RegisterVehicle.vue?vue&type=template&id=3b93889f&"
import script from "./RegisterVehicle.vue?vue&type=script&lang=js&"
export * from "./RegisterVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports